import React from 'react';
import { NiceFormGroup, QuestionWrapper } from './Components.styles';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Waves/Waves.styles';
import { ApIcon, colors } from '@alixpartners/ui-components';

const NumberInput = ({
	questionNo,
	label,
	placeholder,
	handleChange,
	name,
	value,
	required,
	instructions,
}) => {
	return (
		<NiceFormGroup>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<QuestionWrapper>
					<div className="questionNo">{questionNo}.&nbsp;</div>
					<label>{label}</label>
					{instructions && (
						<Tooltip
							position="bottom"
							animation="fade"
							arrow
							html={<TooltipContent>{instructions}</TooltipContent>}
							trigger="mouseenter"
							style={{ marginBottom: '4px', marginLeft: '5px' }}
						>
							<ApIcon
								iconName="info"
								iconSize="22px"
								outlined={true}
								iconColor={colors.green300}
							/>
						</Tooltip>
					)}
				</QuestionWrapper>
			</div>
			<input
				type="text"
				placeholder={placeholder}
				onChange={e => {
					e.target.isNumber = true;
					handleChange(e);
				}}
				name={name}
				value={value}
				required={required}
			/>
		</NiceFormGroup>
	);
};

export default NumberInput;
